const KNOWN_CATEGORIES = new Set([
  "CRITICAL",
  "RISK_STATUS",
  "SENSOR_DATA",
  "STATUS_CHANGE",
  "GENERAL_UPDATE",
  "SYSTEM",
]);

const normalizeCategory = (type) => {
  const category = String(type || "SYSTEM").toUpperCase();
  return KNOWN_CATEGORIES.has(category) ? category : "SYSTEM";
};

export const timelineItemToNotification = (item) => {
  if (!item || typeof item !== "object") return null;

  // Keep support for the older, already-normalized API/FCM shape.
  if (item.message && item.category) {
    return {
      ...item,
      category: normalizeCategory(item.category),
      sourceTool: item.sourceTool || item.source || item.category,
    };
  }

  const category = normalizeCategory(item.type);
  const seniorName = item.quickJump?.senior?.fullName || "Resident";
  const title = item.name || item.action || item.type || category;
  const body = item.summary || "";
  const message = [seniorName, title, body].filter(Boolean).join(" – ");

  return {
    id: item.id,
    category,
    sourceTool: item.source || item.type || category,
    source: item.source || null,
    severity: item.severity || null,
    message,
    personName: seniorName,
    title,
    body,
    time: item.time || "",
    isRead: item.isRead === true,
    iconURL: item.iconURL,
    fromPush: false,
    openUrl: item.quickJump?.reportURL || null,
    quickJump: item.quickJump
      ? {
          destination: undefined,
          seniorId: item.quickJump.senior?.id,
          action: item.quickJump.action,
          reportURL: item.quickJump.reportURL || null,
          moduleId: item.quickJump.moduleId ?? null,
          reportId: item.quickJump.reportId ?? item.quickJump.report_id ?? null,
          revision: item.quickJump.revision ?? null,
          activity_id:
            item.quickJump.activity_id ?? item.quickJump.activityId ?? null,
        }
      : undefined,
  };
};

export const normalizeTimeline = (items) =>
  (Array.isArray(items) ? items : [])
    .map(timelineItemToNotification)
    .filter(Boolean);

// Failed-test updates are informational, even if a stale report URL is present.
export const isNotificationNavigationBlocked = (item) =>
  String(item?.quickJump?.action || "").toUpperCase() === "SEE_TEST_HISTORY";
